import React, { useEffect, useState } from 'react'
import styles from './deleteProduct.module.css'
import ModalComponent from '../../../components/modal/ModalComponent'
import iconAlert from '../../../assets/icons/warning-yellow-ilus.svg'
import Text from '../../../components/text/Text'
import SquareCheckBox from '../../../components/checkBox/SquareCheckBox'
import SvgIcon from '../../../components/svgIcon/SvgIcon'
import Button from '../../../components/buttons/ButtonUI'
import SuccessIcon from '../../../assets/icons/check-fill-green.svg'
import ErrorIcon from '../../../assets/icons/icons-error.svg'
import { useLoadingContext } from '../../../context/spinnerContext'
import { deleteProduct } from '../../../services/products'
import { formatCurrentDate } from '../../../utils'

interface IDeleteProduct {
    product?: IProductObject
    onCancel: () => void
    onSuccess: () => void
}

export function DeleteProduct(properties: IDeleteProduct) {
    const loadingContext = useLoadingContext()

    const [showModalSuccess, setShowModalSuccess] = useState(false)
    const [showModalError, setShowModalError] = useState(false)

    const [isTwo, setIsTwo] = useState(false)

    const [options, setOptions] = useState({
        online: false,
        f2f: false,
    })

    useEffect(() => {
        if (properties.product) {
            setOptions({
                online: properties.product.commerceStock.online,
                f2f: properties.product.commerceStock.f2f,
            })

            if (
                properties.product.commerceStock.online &&
                properties.product.commerceStock.f2f
            ) {
                setIsTwo(true)
            } else {
                setIsTwo(false)
            }
        }
    }, [properties.product])

    const handlerChangeOptions = (key: 'online' | 'f2f') => {
        setOptions((old) => ({
            ...old,
            [key]: !old[key],
        }))
    }

    const handlerDeleteProduct = async () => {
        if (!properties.product) return

        loadingContext?.onOpen()

        const typesDelete = []

        if (options.online) {
            typesDelete.push('ONLINE')
        }

        if (options.f2f) {
            typesDelete.push('F2F')
        }

        try {
            await deleteProduct(properties.product.product.id, {
                ...properties.product,
                types: typesDelete,
            }).then((resp) => {
                properties.onCancel()
                loadingContext?.onClose()
                if (resp.status === 200) {
                    setShowModalSuccess(true)
                } else {
                    setShowModalError(true)
                }
            })
        } catch (err) {
            setShowModalError(true)
        }
    }

    const closeAll = () => {
        setShowModalError(false)
        setShowModalSuccess(false)
    }

    const handlerSuccess = () => {
        closeAll()
        properties.onSuccess()
    }

    const handlerError = () => {
        closeAll()
        properties.onCancel()
    }

    const handlerCancel = () => {
        closeAll()
        properties.onCancel()
    }

    return (
        <>
            <ModalComponent
                icon={false}
                modalStyle={styles.modal}
                show={!!properties.product}
                handleClose={handlerCancel}
            >
                <div className={styles.containerModal}>
                    {isTwo ? (
                        <>
                            <div className={styles.header}>
                                <img src={iconAlert} />
                                <p
                                    style={{
                                        fontFamily: 'Montserrat',
                                        color: '#656565',
                                        marginBottom: 15,
                                        fontWeight: 400,
                                        marginTop: 20,
                                        fontSize: 16,
                                    }}
                                >
                                    Este producto está disponible para <br />
                                    <SvgIcon iconName="IconAmipass" /> Tienda en
                                    APP y venta presencial.
                                </p>
                                <Text
                                    fontFamily="Montserrat"
                                    label="Selecciona en donde quieres eliminar el producto"
                                    fontWeight={400}
                                    fontSize={16}
                                    color="#656565"
                                    textAlign="center"
                                />
                            </div>
                            <div>
                                <div
                                    style={{ marginBottom: 10, marginLeft: 50 }}
                                >
                                    <SquareCheckBox
                                        noBackground
                                        checkId="f2fId"
                                        labelClassName="Body3-12 "
                                        label="Venta para Tienda Física"
                                        onClick={() =>
                                            handlerChangeOptions('f2f')
                                        }
                                        checked={options.f2f}
                                    >
                                        <Text
                                            color="#000"
                                            fontSize={14}
                                            fontWeight={400}
                                            fontFamily="Montserrat"
                                            label="Venta para Tienda Física"
                                        />
                                    </SquareCheckBox>
                                </div>
                                <div
                                    style={{ marginBottom: 20, marginLeft: 50 }}
                                >
                                    <SquareCheckBox
                                        noBackground
                                        checkId="onlineId"
                                        labelClassName="Body3-12 "
                                        label="Tienda en APP"
                                        onClick={() =>
                                            handlerChangeOptions('online')
                                        }
                                        checked={options.online}
                                    >
                                        <div
                                            style={{ display: 'flex', gap: 5 }}
                                        >
                                            <SvgIcon iconName="IconAmipass" />
                                            <Text
                                                color="#000"
                                                fontSize={14}
                                                fontWeight={400}
                                                fontFamily="Montserrat"
                                                label="Tienda en APP"
                                            />
                                        </div>
                                    </SquareCheckBox>
                                </div>
                            </div>
                            <div className={styles.buttons}>
                                <button
                                    className={styles.modalButtonDelete}
                                    onClick={handlerDeleteProduct}
                                    type="button"
                                >
                                    <Text
                                        label="ELIMINAR PRODUCTO"
                                        fontWeight={600}
                                        fontSize={14}
                                        color="#63666A"
                                    />
                                </button>
                                <button
                                    className={`${styles.modalButtonBack} ${styles.buttonBack}`}
                                    onClick={properties.onCancel}
                                    type="button"
                                >
                                    <Text
                                        label="NO HACER NADA"
                                        fontWeight={600}
                                        fontSize={14}
                                        color="#fff"
                                    />
                                </button>
                            </div>
                        </>
                    ) : (
                        <>
                            <div className={styles.header}>
                                <img src={iconAlert} />
                                <Text
                                    label="Estás a punto de eliminar un producto de tu tienda."
                                    fontWeight={400}
                                    fontSize={16}
                                    color="#656565"
                                    textAlign="center"
                                    marginTop={20}
                                />
                                <Text
                                    label="¿Estás seguro?"
                                    fontWeight={400}
                                    fontSize={16}
                                    color="#656565"
                                    textAlign="center"
                                />
                            </div>
                            <div className={styles.buttons}>
                                <button
                                    className={styles.modalButtonDelete}
                                    onClick={handlerDeleteProduct}
                                    type="button"
                                >
                                    <Text
                                        label="ELIMINAR PRODUCTO"
                                        fontWeight={600}
                                        fontSize={14}
                                        color="#63666A"
                                    />
                                </button>
                                <button
                                    className={`${styles.modalButtonBack} ${styles.buttonBack}`}
                                    onClick={properties.onCancel}
                                    type="button"
                                >
                                    <Text
                                        label="NO HACER NADA"
                                        fontWeight={600}
                                        fontSize={14}
                                        color="#fff"
                                    />
                                </button>
                            </div>
                        </>
                    )}
                </div>
            </ModalComponent>
            <ModalComponent
                icon={false}
                show={showModalSuccess}
                handleClose={handlerSuccess}
                modalStyle={styles.modalSuccessProduct}
            >
                <div className={styles.modalSuccessProductContent}>
                    <img src={SuccessIcon} />
                    <Text
                        textAlign="center"
                        color="#565656"
                        fontFamily="Montserrat"
                        fontWeight={500}
                        fontSize={16}
                        label={`Producto eliminado del inventario ${formatCurrentDate()}`}
                    />
                    <Button
                        onClick={handlerSuccess}
                        type="button"
                        label="Continuar"
                        variant="success"
                        textVariant="md14"
                    />
                </div>
            </ModalComponent>
            <ModalComponent
                icon={false}
                show={showModalError}
                handleClose={handlerError}
                modalStyle={styles.modalErrorProduct}
            >
                <div className={styles.modalErrorProductContent}>
                    <img src={ErrorIcon} />
                    <Text
                        textAlign="center"
                        color="#565656"
                        fontFamily="Montserrat"
                        fontWeight={600}
                        fontSize={16}
                        marginBottom={12}
                        label="Ocurrió un error al intentar Eliminar el producto."
                    />
                    <Text
                        textAlign="center"
                        color="#565656"
                        fontFamily="Montserrat"
                        fontWeight={400}
                        fontSize={14}
                        label="Por favor, intente nuevamente. Si el problema persiste, contacta a soporte."
                    />
                    <button onClick={handlerError} className={styles.btnError}>
                        <Text
                            label="Aceptar"
                            color="#fff"
                            fontFamily="Montserrat"
                            fontSize={14}
                            fontWeight={600}
                        />
                    </button>
                </div>
            </ModalComponent>
        </>
    )
}
